import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    keytable: 0,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('prevendaitem', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async findDetalhado(_, id) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`prevendaitem/detalhado/${id}`),
      ]);

      return data;
    },

    async create({ commit }, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('prevendaitem/app', body),
      ]);
      commit('prevenda/ADD_PREVENDA_QUANTIDADE', body.pviquantidade, { root: true });
      commit('SET_KEYTABLE', 1);
      return data;
    },

    async createAll(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.post('prevendaitem/all', body),
      ]);

      return data;
    },

    async update({ commit }, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.put(`prevendaitem/app/${body.id}`, body),
      ]);
      commit('prevenda/ADD_PREVENDA_QUANTIDADE', 1, { root: true });
      commit('SET_KEYTABLE', 1);
      return data;
    },

    async delete({ commit }, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.delete(`prevendaitem/app/${body.id}`, body),
      ]);
      commit('prevenda/DELETE_PREVENDA_QUANTIDADE', 1, { root: true });
      commit('SET_KEYTABLE', 1);
      return data;
    },

    async deletePorEmpresa(_, body) {
      const [{ data }] = await Promise.all([
        apiempresaweb.delete(`prevendaitem/empresa/${body.id}`, body),
      ]);

      return data;
    },

    async count(_, { id }) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get(`prevendaitem/count/${id}`),
      ]);

      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_KEYTABLE(state, key) {
      state.keytable += key;
    },
    CLEAR_KEYTABLE(state) {
      state.keytable = 0;
    },
  },
};
